module.exports = {
  sms: require('./sms'),
  connection: require('./connection'),
  airtime: require('./airtime'),
  globals: require('./globals'),
  notification: require('./notification'),
  payment: require('./payment'),
  ussd: require('./ussd')
};
